import { z } from "zod/v4";

import { OrganizationListDtoSchema } from "../../../dtos/organizations-list";

export const GetOrganizationsListResponseBodySchema = z.object({
  orgs: OrganizationListDtoSchema.array(),
});

export type GetOrganizationsListResponseBodyType = z.infer<
  typeof GetOrganizationsListResponseBodySchema
>;
